import React from "react";

const NODES = [
  { id: "N01", label: "Engine mapping", value: "Turbo efficiency 98.2%", pos: "top-[14%] left-4", line: "left" },
  { id: "N02", label: "Exhaust flow", value: "Backpressure nominal", pos: "top-[20%] right-4", line: "right" },
  { id: "N03", label: "Thermal diag", value: "92°C — normal", pos: "top-[46%] left-4", line: "left" },
  { id: "N04", label: "Camshaft timing", value: "Optimal — ±0.02°", pos: "top-[52%] right-4", line: "right" },
];

export const HeroCallouts = () => (
  <div className="pointer-events-none absolute inset-0 z-10 hidden md:block" data-testid="hero-callouts">
    {NODES.map((n) => (
      <div key={n.id} className={`absolute ${n.pos} flex items-center gap-0 float-y`} style={{ animationDelay: `${parseInt(n.id.slice(1), 10) * 0.7}s` }}>
        {n.line === "right" && <span className="h-px w-10 lg:w-20 bg-gradient-to-l from-brand-red/80 to-transparent order-2" />}
        {n.line === "right" && <span className="h-1.5 w-1.5 rounded-full bg-brand-red node-pulse order-3" />}
        <div className={`border border-brand-red/40 bg-black/75 backdrop-blur px-3 py-1.5 ${n.line === "right" ? "order-1" : ""}`}>
          <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-brand-red">{n.label}</div>
          <div className="font-mono text-[10px] text-zinc-300 mt-0.5">{n.value}</div>
        </div>
        {n.line === "left" && <span className="h-px w-10 lg:w-20 bg-gradient-to-r from-brand-red/80 to-transparent" />}
        {n.line === "left" && <span className="h-1.5 w-1.5 rounded-full bg-brand-red node-pulse" />}
      </div>
    ))}
  </div>
);
